import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row, Table } from 'reactstrap';
import { ICrudGetAllAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntities } from './application-configuration.reducer';
import { IApplicationConfiguration } from 'app/shared/model/application-configuration.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IApplicationConfigurationProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {}

export const ApplicationConfiguration = (props: IApplicationConfigurationProps) => {
  useEffect(() => {
    props.getEntities();
  }, []);

  const { applicationConfigurationList, match, loading } = props;
  return (
    <div>
      <h2 id="application-configuration-heading">
        Application Configurations
        <Link to={`${match.url}/new`} className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
          <FontAwesomeIcon icon="plus" />
          &nbsp; Create new Application Configuration
        </Link>
      </h2>
      <div className="table-responsive">
        {applicationConfigurationList && applicationConfigurationList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>ID</th>
                <th>Configuration Name</th>
                <th>Configuration Value</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {applicationConfigurationList.map((applicationConfiguration, i) => (
                <tr key={`entity-${i}`}>
                  <td>
                    <Button tag={Link} to={`${match.url}/${applicationConfiguration.id}`} color="link" size="sm">
                      {applicationConfiguration.id}
                    </Button>
                  </td>
                  <td>{applicationConfiguration.configurationName}</td>
                  <td>{applicationConfiguration.configurationValue}</td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${applicationConfiguration.id}`} color="info" size="sm">
                        <FontAwesomeIcon icon="eye" /> <span className="d-none d-md-inline">View</span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${applicationConfiguration.id}/edit`} color="primary" size="sm">
                        <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${applicationConfiguration.id}/delete`} color="danger" size="sm">
                        <FontAwesomeIcon icon="trash" /> <span className="d-none d-md-inline">Delete</span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && <div className="alert alert-warning">No Application Configurations found</div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ applicationConfiguration }: IRootState) => ({
  applicationConfigurationList: applicationConfiguration.entities,
  loading: applicationConfiguration.loading,
});

const mapDispatchToProps = {
  getEntities,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationConfiguration);
